/* Implementation of the Night Owl theme for VS Code
Original: https://github.com/sdras/night-owl-vscode-theme */

.prism-code-editor {
	font-family: Consolas, Monaco, "Andale Mono", "Ubuntu Mono", monospace;
	--pce-cursor: #80a4c2;
	--pce-bg: #011627;
	--pce-widget-border: #122d42;
	--pce-widget-bg: #021320;
	--pce-widget-color: #d6deeb;
	--pce-widget-color-active: #fff;
	--pce-widget-color-options: #b3bccc;
	--pce-widget-bg-input: #0b253a;
	--pce-widget-bg-hover: #5a5d5e80;
	--pce-widget-bg-active: #122d4266;
	--pce-widget-focus: #5f7e97;
	--pce-search-match: #5f7e9778;
	--pce-widget-bg-error: #ab0300f2;
	--pce-widget-error: #ef5350;
	--pce-bg-highlight: #0003;
	--pce-selection-match: #5f7e9778;
	--pce-line-number: #4b6479;
	--pce-scrollbar: 206, 88%, 27%;
	--pce-bg-fold: #c5c5c5;
	--pce-guide-indent: #5e81ce52;
	--pce-ac-icon-class: #ee9d28;
	--pce-ac-icon-enum: #ee9d28;
	--pce-ac-icon-event: #ee9d28;
	--pce-ac-icon-function: #b180d7;
	--pce-ac-icon-interface: #75beff;
	--pce-ac-icon-variable: #75beff;
	--pce-selection: #1d3b53;
	color-scheme: dark;
}

.match-highlight {
	--pce-bg-highlight: #7e57c259;
}

.pce-match {
	--pce-search-match: #545a8b;
}

.active-line {
	--pce-line-number: #c5e4fd;
}

.active-indent {
	--pce-guide-indent: #b3cfe7b3;
}

/* Tokens */

.token.comment,
.token.prolog,
.token.cdata {
	color: #637777;
	font-style: italic;
}

.token.namespace {
	opacity: 0.7;
}

.token.property {
	color: #80cbc4;
}

.token.keyword,
.token.punctuation,
.token.literal-property,
.token.operator,
.token.token.anchor,
.token.atrule .rule,
.language-css .important,
.language-markdown .italic * {
	color: #c792ea;
}

[class*="language-"],
.language-css .punctuation,
.block > .punctuation,
.token.code.keyword,
.token.url > .content {
	color: #d6deeb;
}

.selector .punctuation {
	color: #c792ea;
}

.token.tag,
.token.doctype-tag {
	color: #caece6;
}

.token.number,
.regex .escape,
.token.tag > .class-name {
	color: #f78c6c;
}

.token.boolean,
.token.keyword-null {
	color: #ff5874;
}

.token.selector {
	color: #ff6363;
}

.language-markdown .token.url,
.token.deleted {
	color: #ff869a;
}

.token.atrule,
.token.parameter {
	color: #d7dbe0;
}

.token.color,
.token.tag > .punctuation,
.token.attr-name > .punctuation,
.token.doctype > .punctuation,
.selector .combinator,
.selector .operator,
.token.attr-equals,
.token.property-access,
.token.quantifier,
.token.alternation,
.token.url > .markup-bracket {
	color: #7fdbca;
}

.token.unit,
.token.hexcode {
	color: #ffeb95;
}

.language-regex,
.token.regex-flags {
	color: #5ca7e4;
}

.selector .id {
	color: #fad430;
}

.token.attr-value > .punctuation {
	color: #d9f5dd;
}

.token.attr-name,
.token.doctype,
.token.variable,
.token.inserted,
.selector .class,
.selector .pseudo-element,
.selector .pseudo-class,
.token.builtin,
.token.bold *,
.token.code.code-snippet {
	color: #c5e478;
}

.token.function,
.token.constant,
.token.keyword-undefined,
.token.function .maybe-class-name,
.token.entity,
.token.char-class,
.token.token.char-set,
.token.title.important,
.token.title > .punctuation,
.token.url > .variable {
	color: #82aaff;
}

.token.attr-value,
.token.char,
.token.string,
.token.string-property {
	color: #ecc48d;
}

.token.class-name,
.token.maybe-class-name {
	color: #ffcb8b;
}

.token.important,
.token.bold {
	font-weight: bold;
}

.token.function,
.token.keyword,
.token.italic,
.token.attr-name,
.token.pseudo-class,
.token.pseudo-element,
.selector .class,
.selector .id,
.token.atrule .rule,
.doctype .name {
	font-style: italic;
}

.language-css .function {
	color: #c5e478;
	font-style: normal;
}

.token.alternation,
.token.keyword-this,
.token.keyword-null,
.token.keyword-undefined {
	font-style: normal;
}

/* Brackets */

.token.bracket-level-0,
.token.bracket-level-3,
.token.bracket-level-6,
.token.bracket-level-9 {
	color: #ffd700;
}

.token.bracket-level-1,
.token.bracket-level-4,
.token.bracket-level-7,
.token.bracket-level-10 {
	color: #da70d6;
}

.token.bracket-level-2,
.token.bracket-level-5,
.token.bracket-level-8,
.token.bracket-level-11 {
	color: #179fff;
}

.token.interpolation-punctuation {
	color: #d3423e;
}

.token.bracket-error {
	color: #ff1212;
}

.token.markup-bracket,
.token.regex .punctuation {
	color: inherit;
}

.active-bracket {
	box-shadow: inset 0 0 0 1px #b3cfe7a1, inset 0 0 0 9in #5f7e974d;
}

.active-tagname,
.word-matches span {
	background: #f6bbe533;
}
